// @flow

export const APP_INITIAL = 'APP_INITIAL';
export const APP_LOADING = 'APP_LOADING';
export const APP_MODAL_ACTIVATOR = 'APP_MODAL_ACTIVATOR';
export const APP_ERROR = 'APP_ERROR';
export const APP_UPDATE_STATE = 'APP_UPDATE_STATE';
